<template>
    <div class="modal-add-briefings" v-if="add_briefing">
        <div class="div-add-briefings">
            <error-component :errors="errors" v-if="showErrorBriefing"/>
            <h2 v-if="add_briefing_btn">Ver</h2>

            <div @click="closeModalBriefing" class="btn-close"></div>
            <row-component>
                <row-col-component :class-row-col="'col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12'"
                                   :class="{ 'formError': errors.name }">
                    <label>Nome:</label>
                    <input-component disabled :type-input="'text'" v-model="formDateBriefings.name"/>
                </row-col-component>

                <row-col-component
                        :class-row-col="'col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mt-4'">
                    <label>Visível para time?:</label>

                    <input disabled type="radio" id="nao" name="teste" v-model="formDateBriefings.visible" value="1">
                    <label for="nao">Não</label>

                    <input disabled type="radio" id="sim" name="teste" v-model="formDateBriefings.visible" value="2">
                    <label for="sim">Sim</label>
                </row-col-component>
            </row-component>

            <row-col-component :class-row-col="'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'"
                               :class="{ 'formError': errors.desc }">
                <label>Descrição:</label>
                <QuillEditor disabled :theme="'bubble'" :toolbar="toolbarOptions" :contentType="'html'" ref="myEditor"
                             v-model:content="formDateBriefings.desc"
                             style="max-height:280px; overflow: scroll;margin-bottom: 2%"/>
            </row-col-component>
        </div>
    </div>

    <painel-component :itens="itensOne">
        <error-component :errors="errors" v-if="showError"/>
        <loder-send-component :text-title="'Carregando'" v-if="showLoder"/>

        <div class="tabs effect-3" v-else>
            <input checked type="radio" id="tab-1" name="tab-effect-3">
            <span :class="{'span-password' : !view_password}">
                <i class="info circle icon"></i>
                <p>Informações</p>
            </span>

            <input v-if="view_password" type="radio" id="tab-2" name="tab-effect-3">
            <span v-if="view_password">
                <i class="lock icon"></i>
                <p>Senha</p>
            </span>

            <input type="radio" id="tab-3" name="tab-effect-3">
            <span :class="{'span-password' : !view_password}">
                <i class="file alternate icon"></i>
                <p>Briefing</p>
            </span>

            <input type="radio" id="tab-4" name="tab-effect-3">
            <span :class="{'span-password' : !view_password}">
                <i class="file word icon"></i>
                <p>Docs/Refs</p>
            </span>

            <div class="line ease"></div>
            <div class="tab-content">
                <section id="tab-item-1">
                    <form autocomplete="off">
                        <row-component>
                            <row-col-component
                                    :class-row-col="'col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'">
                                <label>Nome:</label>
                                <Multiselect disabled :searchable="true" v-model="formDate.client_id" label="name"
                                             :options="selectClientList">
                                    <template v-slot:singlelabel="{ value }">
                                        <div class="multiselect-single-label">
                                            <img alt="" class="character-label-icon" :src="value.icon"> {{ value.name }}
                                        </div>
                                    </template>

                                    <template v-slot:option="{ option }">
                                        <img alt="" class="character-option-icon" :src="option.icon"> {{ option.name }}
                                    </template>
                                </Multiselect>
                            </row-col-component>

                            <row-col-component
                                    :class-row-col="'col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'">
                                <label>Status:</label>
                                <multiselect disabled v-model="formDate.status" :searchable="true"
                                             :options="selectInput"
                                             :noResultsText="this.$store.state.var.selectNotSearch"/>
                            </row-col-component>
                        </row-component>
                    </form>

                    <row-component>
                        <row-col-component :class-row-col="'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'">
                            <button-float style="width: 100%;" :itens="itensTwo"/>
                        </row-col-component>
                    </row-component>
                </section>

                <section v-if="view_password" id="tab-item-2" class="position-relative">
                    <div class="alert alert-secondary alert-dismissible fade show mt-5" role="alert"
                         v-if="formDate.passwords.length === 0">
                        <p>Não há nada cadastrado</p>
                    </div>

                    <row-component v-else class="mt-5 container-section" v-for="(password, index) in formDate.passwords"
                                   :key="index">
                        <row-col-component
                                :class-row-col="'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'">
                            <label>Nome:</label>
                            <input-component disabled :type-input="'text'" v-model="password.name"/>
                        </row-col-component>

                        <row-col-component
                                :class-row-col="'col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'">
                            <label>Link:</label>
                            <input-component disabled :type-input="'text'" v-model="password.link"/>
                        </row-col-component>

                        <row-col-component
                                :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                            <label>Login:</label>
                            <input-component disabled :type-input="'text'" v-model="password.login"/>
                        </row-col-component>

                        <row-col-component
                                :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                            <label>Senha:</label>
                            <div class="password-field">
                                <input-component :id="'passwordField' + index" disabled type-input="password"
                                                 v-model="password.password"/>
                                <i :id="'eyeIcon' + index" @click="passwordEye(index)"
                                   v-if="view_password_show"
                                   class="eye icon"></i>
                                <i style="display: none" :id="'eyeSlash' + index" @click="passwordEye(index)"
                                   v-if="view_password_show"
                                   class="eye slash icon"></i>
                            </div>
                        </row-col-component>
                    </row-component>
                </section>

                <section id="tab-item-3">
                    <div class="alert alert-secondary alert-dismissible fade show mt-5" role="alert"
                         v-if="formDate.brifings.length === 0">
                        <p>Não há nada cadastrado</p>
                    </div>

                    <row-component v-else class="mt-5">
                        <row-col-component
                                :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'"
                                v-for="(briefings, index) in formDate.brifings" :key="index">

                            <div class="file-content">
                                <label>
                                    <img :src="briefings.photo" alt="">
                                    <p>{{ briefings.name }}</p>
                                </label>
                                <div class="action-buttons">
                                    <button @click="updateCustomerProfileBriefing(index, briefings.id)">
                                        <i class="eye icon"></i>
                                    </button>
                                </div>
                            </div>
                        </row-col-component>
                    </row-component>
                </section>

                <section id="tab-item-4">
                    <div class="alert alert-secondary alert-dismissible fade show mt-5" role="alert"
                         v-if="formDate.files.length === 0">
                        <p>Não há nada cadastrado</p>
                    </div>

                    <row-component v-else class="mt-5">
                        <row-col-component :class-row-col="'col-xxl-3 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'"
                                           v-for="(file, index) in formDate.files" :key="index">
                            <div class="card">
                                <div class="card-image">
                                    <a :href="file.name_encoded" target="_blank"
                                       v-if="typeExtension(file.name_encoded) === 'png' && 'jpeg' && 'jpg'">
                                        <img :src="file.name_encoded" alt="">
                                    </a>

                                    <i v-else-if="typeExtension(file.name_encoded) === 'pdf'"
                                       class="file pdf icon"></i>

                                    <i v-else-if="typeExtension(file.name_encoded) === 'docx' && 'doc'"
                                       class="file word icon"></i>

                                    <i v-else class="file excel icon"></i>
                                </div>

                                <p>{{ file.name_original }}</p>

                                <div class="aux-row-3">
                                    <div class="text"><i class="calendar icon"></i>{{ file.date_create }}</div>
                                    <div class="text"><i class="clock icon"></i>{{ file.hour_create }}</div>
                                </div>
                                <div class="ow-img">
                                    <img :src="file.user_photo" alt=""/>
                                    Enviado por: {{ file.user_name }}
                                </div>
                                <div class="dates-card">
                                    <button style="width: 100%" @click="previewFiles(file.name_encoded)"
                                            class="btn btn-secondary buttonRound" type="button">
                                        <i class="eye icon"></i>
                                    </button>
                                </div>
                            </div>
                        </row-col-component>
                    </row-component>
                </section>

            </div>
        </div>

    </painel-component>
</template>

<script>
import PainelComponent from "@/components/dashboard/PainelComponent";
import RowComponent from "@/components/row/RowComponent";
import RowColComponent from "@/components/row/RowColComponent";
import ButtonFloat from "@/components/buttons/ButtonFloat";
import Multiselect from "@vueform/multiselect";
import ErrorComponent from "@/components/alerts/ErrorComponent"
import LoderSendComponent from "@/components/LoderSendComponent";
import {QuillEditor} from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import '@vueup/vue-quill/dist/vue-quill.bubble.css'
import {useToast} from "vue-toastification";
import InputComponent from "@/components/form/InputComponent.vue";

const toast = useToast();

export default {
    name: "CustomerProfileShow",

    components: {
        InputComponent,
        PainelComponent,
        RowComponent,
        RowColComponent,
        ButtonFloat,
        Multiselect,
        ErrorComponent,
        LoderSendComponent,
        QuillEditor
    },

    props: {
        id: {
            required: true
        }
    },

    created() {
        this.$store.dispatch('updateNamePage', 'Perfil do Cliente')
        this.$store.dispatch('loadClientListSelect')
        this.loadCustomerProfile()
        this.checkACL()
    },

    data() {
        return {
            itensOne: {
                title: "Ver",
                icon: "eye"
            },

            itensTwo: {
                route: "/customer-profile/search",
                icon: "reply all",
                name: 'Voltar'
            },

            formDate: {
                client_id: '',
                status: '',
                passwords: [],
                brifings: [],
                files: []
            },

            add_password: false,
            showErrorPass: false,
            view_password: false,
            add_password_btn: false,
            view_password_show: false,

            url_file: '',
            contUpload: 0,
            add_files: false,
            preview_files: false,

            formDateBriefings: {
                profile_id: this.id,
                name: '',
                visible: 1,
                desc: ''
            },

            add_briefing: false,
            add_briefing_btn: false,
            showErrorBriefing: false,

            toolbarOptions: [
                ['bold', 'italic', 'underline', 'strike'],
                ['blockquote', 'code-block'],
                [{'header': 1}, {'header': 2}],
                [{'list': 'ordered'}, {'list': 'bullet'}],
                [{'script': 'sub'}, {'script': 'super'}],
                [{'indent': '-1'}, {'indent': '+1'}],
                [{'direction': 'rtl'}],
                [{'size': ['small', false, 'large', 'huge']}],
                [{'header': [1, 2, 3, 4, 5, 6, false]}],
                [{'color': []}, {'background': []}],
                [{'font': []}],
                [{'align': []}],
                ['clean']
            ],

            errors: [],
            showError: false,
            sendForm: false,
            showLoder: true,
        }
    },

    methods: {

        async checkACL() {
            this.$store.dispatch('ACLitens', 39)
                .then((r) => {
                    if (r.data.indexOf('profile-search') !== -1) {
                        this.showLoder = false

                        if (r.data.indexOf('profile-password') !== -1) {
                            this.view_password = true
                        }

                        if (r.data.indexOf('profile-password-show') !== -1) {
                            this.view_password_show = true
                        }

                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },

        scrollTop() {
            window.scrollTo(0, 0)
        },

        loadCustomerProfile() {
            this.$store.dispatch('loadCustomerProfile', this.id)
                .then((r) => {
                    this.formDate = r
                })
                .catch(() => {
                    toast.error("Erro desconhecido", {timeout: 1000});
                })
        },

        passwordEye(index) {
            let eyeIcon = document.getElementById('eyeIcon' + index)
            let eyeSlash = document.getElementById('eyeSlash' + index)
            let passwordField = document.getElementById('passwordField' + index)

            if (eyeSlash.style.display === 'none') {
                eyeIcon.style.display = 'none'
                eyeSlash.style.display = 'block'
                passwordField.type = 'text'
            } else {
                eyeIcon.style.display = 'block'
                eyeSlash.style.display = 'none'
                passwordField.type = 'password'
            }
        },

        typeExtension(name) {
            return name.split('.').pop()
        },

        previewFiles(file) {
            let ext = file.split('.').pop()

            if (ext !== 'png' && 'jpeg' && 'jpg') {
                window.open(file, '_blank')
            } else {
                this.url_file = file
                this.preview_files = true
            }
        },

        closeModalBriefing() {
            this.formDateBriefings = {}
            this.add_briefing = false
            this.add_briefing_btn = false
        },

        updateCustomerProfileBriefing(index, id) {
            this.formDateBriefings = this.formDate.brifings[index]
            this.add_briefing = true
            this.add_briefing_btn = true
            this.formDateBriefings.id_briefing = id
            delete Object.assign(this.formDateBriefings, {['profile_id']: this.formDateBriefings['id']})['id'];
        },

    },

    computed: {

        selectClientList() {
            return this.$store.state.var.selectClientList;
        },

        selectInput() {
            return this.$store.state.var.selectActiveInactive;
        },

        files_computed() {
            return this.formDateFile
        },
    }

}
</script>

<style scoped>
.tabs > span.span-password,
.effect-3 .line.span-password {
    width: calc(100% / 3);
}

#tab-3, #tab-3 + span.span-password,
#tab-3:checked ~ .line.span-password {
    left: 33.3%;
}

#tab-4, #tab-4 + span.span-password,
#tab-4:checked ~ .line.span-password {
    left: 66.6%;
}

#tab-2, #tab-2 + span,
#tab-2:checked ~ .line {
    left: 25%;
}

#tab-3, #tab-3 + span,
#tab-3:checked ~ .line {
    left: 50%;
}

#tab-4, #tab-4 + span,
#tab-4:checked ~ .line {
    left: 75%;
}

.tabs > input,
.tabs > span,
.effect-3 .line {
    width: 25%;
}

.container-section {
    padding: 35px 10px;
    position: relative;
    background: #f0f0f0;
}

.password-field {
    position: relative;
}

.password-field i.eye {
    top: 8px;
    right: 5px;
    cursor: pointer;
    position: absolute;
}

.modal-add-briefings {
    top: 0;
    left: 0;
    width: 100vw;
    z-index: 100;
    height: 100vh;
    display: grid;
    position: fixed;
    place-items: center;
    background: rgb(0, 0, 0, 0.6);
}

.modal-add-briefings .div-add-briefings {
    width: 60%;
    padding: 2%;
    height: auto;
    box-shadow: none;
    position: relative;
    background: #FFFFFF;
    margin: 5% 2% 5% 2%;
}

.modal-add-briefings .div-add-briefings h2 {
    width: fit-content;
    font-family: 'Comfortaa', cursive;
    font-size: 20px;
    position: relative;
    left: 0;
    top: -19px;
    color: #000;
    font-weight: 50;
}

.modal-add-briefings .btn-close {
    top: 0;
    right: 0;
    margin: 2%;
    cursor: pointer;
    position: absolute;
}

.modal-files-preview span {
    top: 0;
    right: 0;
    margin: 2%;
    width: 50px;
    height: 50px;
    display: block;
    background: white;
    position: absolute;
    border-radius: 50%;
    padding: 0.4rem 0.5rem;
}

.modal-files-preview .btn-close {
    font-size: 1.5rem;
    position: relative;
}

/*#############################*/

.window-files-preview > img {
    background-color: rgba(0, 0, 0, 0.7);
    -webkit-box-shadow: 0 5px 20px 2px rgba(0, 0, 0, 0.7);
    box-shadow: 0 5px 20px 2px rgba(0, 0, 0, 0.7);
    display: block;
    max-height: 80vh;
    max-width: 80vw;
    position: relative;
    -webkit-transition: -webkit-transform 0.3s ease-in-out;
    transition: -webkit-transform 0.3s ease-in-out;
}

.card {
    width: 90%;
    margin: 1rem;
    font-size: 1rem;
    max-width: 20rem;
    min-height: 24rem;
    position: relative;
    display: inline-block;
    text-decoration: none;
    box-shadow: 0 0 3rem -1rem rgba(0, 0, 0, 0.5);
    transition: transform 0.1s ease-in-out, box-shadow 0.1s;
}

.card-image {
    display: block;
    object-fit: contain;
    text-align: center;
}

.card-image i.icon {
    display: initial;
    font-size: 8rem;
}

.card-image a > img {
    width: 100%;
    display: block;
}

.card:hover {
    transform: translateY(-0.5rem) scale(1.0125);
    box-shadow: 0 0.5em 3rem -1rem rgba(0, 0, 0, 0.5);
}

.card p {
    margin-top: 5px;
    margin-bottom: 5px;
    text-align: center;
}

.ow-img {
    width: 100%;
    display: flex;
    padding: 10px 10px;
    margin-bottom: 5px;
    align-items: center;
}

.ow-img > img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
}

.aux-row-3 {
    display: flex;
    justify-content: space-evenly
}

.dates-card {
    bottom: 0;
    opacity: 1;
    width: 100%;
    height: 15%;
    display: flex;
    position: absolute;
    place-items: center;
    place-content: space-evenly;
}

.dates-card button {
    margin: 0;
    width: 50%;
    height: 100%;
    border-radius: 0;
}

/*#############################*/

.file-content {
    width: 100%;
    height: 60px;
    display: flex;
    color: black;
    padding: 15px 0;
    position: relative;
    align-items: center;
    background: #ebebeb;
    justify-content: space-between;
}

.file-content label {
    width: 100%;
    display: flex;
    cursor: pointer;
    align-items: center;
}

.file-content label img {
    height: auto;
    width: 50px;
    border-radius: 50%;
    margin: 0 10px 0 5px;
}

.file-content label p {
    margin: 0;
    width: 85%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.action-buttons {
    top: 0;
    right: 0;
    height: 100%;
    display: flex;
    position: absolute;
}

.action-buttons > button {
    border: 0;
    width: 55px;
    padding: 5px;
    height: 100%;
    background: #ebebeb;
}

.action-buttons > div {
    border: 0;
    width: 30px;
    padding: 5px;
    display: grid;
    place-items: center;
    background: #ebebeb;
}

@media (max-width: 428px) {

    .modal-add-briefings .div-add-briefings {
        width: 95%;
    }

}

</style>